import { Injectable } from '@angular/core';
import { produce } from 'immer';
import { Question } from '../models/question/question.model';
import { Section } from '../models/section.model';
import { RendererSectionsRepository } from '../repositories/renderer-sections.repository';
import { RendererQuestionsCommand } from './renderer-questions.command';

@Injectable({ providedIn: 'root' })
export class RendererSectionsCommand {
  constructor(
    protected rendererSectionRepository: RendererSectionsRepository,
    protected rendererQuestionsCommand: RendererQuestionsCommand,
  ) {}

  public setSections(sections: Section[]) {
    for (const section of sections) {
      const filteredSection = this.filterOrder(section, section.questions);
      this.rendererQuestionsCommand.setQuestions(filteredSection.questions);
      this.rendererSectionRepository.upsert(filteredSection);
    }
  }

  public setSection(section: Section) {
    this.rendererQuestionsCommand.setQuestions(section.questions);
    this.rendererSectionRepository.upsert(section);
  }

  public setActive(sectionId: string) {
    this.rendererSectionRepository.setActive(sectionId);
  }

  public unsetActive() {
    // eslint-disable-next-line unicorn/no-null
    this.rendererSectionRepository.setActive(null);
  }

  public reset() {
    this.rendererQuestionsCommand.reset();
    this.rendererSectionRepository.reset();
  }

  public updateHoverSection(sectionId) {
    this.rendererSectionRepository.setHoverSection(sectionId);
  }

  private filterOrder(section: Section, questionList: Question[]) {
    return produce(section, (draft) => {
      for (const [index, row] of draft.structure.order.entries()) {
        draft.structure.order[index] = row.filter((qId) =>
          questionList.some((q) => q.id === qId),
        );
      }
      draft.structure.order = draft.structure.order.filter((o) => o.length > 0);
    });
  }
}
